import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderTitleService } from 'src/app/modules/general/services/title.service';

@Component({
  selector: 'app-product-page',
  templateUrl: './booking-products.component.html',
  styleUrls: ['./booking-products.component.css'],
})
export class BookingProductsComponent implements OnInit, OnDestroy {

  constructor(
    private headerTitleService: HeaderTitleService,
  ) { }

  ngOnInit(): void {
    this.headerTitleService.isVisibleTitle = true;
  }

  ngOnDestroy(): void {
    this.headerTitleService.isVisibleTitle = false;
  }
}
